import OrderHistory from "../components/sections/OrderHistory";
import ProductFilter from "../components/sections/ProductFilter/ProductFilter";
import ProductList from "../components/sections/ProductList";
import PromoCarousel from "../components/sections/PromoCarousel/PromoCarousel";

export default function Home() {
  return (
    <>
      <div className="h-[1px] w-full bg-gray-300 shadow-md " />
      <PromoCarousel />
      <div className="h-[1px] w-full bg-gray-300 shadow-md mb-6" />

      <div className="flex flex-col lg:flex-row gap-4">
        {/* Left Sticky Sidebar */}
        <div className="lg:basis-1/5 lg:sticky top-4 self-start h-fit order-0 lg:order-none">
          <ProductFilter />
        </div>

        {/* Main Product List */}
        <div className="lg:basis-3/5 order-1 lg:order-none">
          <ProductList />
        </div>

        {/* Right Sticky Sidebar */}
        <div className="lg:basis-1/5 sticky top-4 self-start h-fit order-2 lg:order-none mx-auto">
          <OrderHistory />
        </div>
      </div>
    </>
  );
}
